export function getFolderNameIconModelBySlug(slug) {
    if (slug.includes('arch')) {
      return 'arch';
    }

    return slug;
}
